import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import {faGamepad, faMailBulk, faPhone} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faTwitter,
	faGithub,
	faStackOverflow,
	faInstagram, faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import Logo from "../components/common/logo";
import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import Article from "../components/homepage/article";
import Works from "../components/homepage/works";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";
import myArticles from "../data/articles";

import "./styles/homepage.css";
import WorkExperience from "../components/workExperiences/workExperience";
import AllWorkExperiences from "../components/workExperiences/allWorkExperiences";

const Homepage = () => {
	const [stayLogo, setStayLogo] = useState(false);
	const [logoSize, setLogoSize] = useState(80);
	const [oldLogoSize, setOldLogoSize] = useState(80);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			let scroll = Math.round(window.pageYOffset, 2);

			let newLogoSize = 80 - (scroll * 4) / 10;

			if (newLogoSize < oldLogoSize) {
				if (newLogoSize > 40) {
					setLogoSize(newLogoSize);
					setOldLogoSize(newLogoSize);
					setStayLogo(false);
				} else {
					setStayLogo(true);
				}
			} else {
				setLogoSize(newLogoSize);
				setStayLogo(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [logoSize, oldLogoSize]);

	const currentSEO = SEO.find((item) => item.page === "home");

	const logoStyle = {
		display: "flex",
		position: stayLogo ? "fixed" : "relative",
		top: stayLogo ? "3vh" : "auto",
		zIndex: 999,
		border: stayLogo ? "1px solid white" : "none",
		borderRadius: stayLogo ? "50%" : "none",
		boxShadow: stayLogo ? "0px 4px 10px rgba(0, 0, 0, 0.25)" : "none",
	};

	return (
		<React.Fragment>
			<Helmet>
				<title>{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				{/*<NavBar active="home" />*/}
				<div className="content-wrapper">
					<div className="homepage-logo-container">
						<div style={logoStyle}>
							<Logo width={logoSize} link={false} />
						</div>
					</div>

					<div className="homepage-container">
						<div className="homepage-first-area">
							<div className="homepage-first-area-left-side">
								<div className="title homepage-subtitle">
									{INFO.homepage.title}
								</div>

								<div className="subtitle homepage-subtitle">
									{INFO.homepage.description}
								</div>
							</div>

							<div className="homepage-first-area-right-side">
								<div className="homepage-image-container">
									<div className="homepage-image-wrapper">
										<img
											src="portrait.JPG"
											alt="about"
											className="homepage-image"
										/>
									</div>
								</div>
							</div>
						</div>

						<div className={"homepage-socials-container"}>
						<ul className="homepage-socials-phone" >
						<li className={"social-li"}>
								<span className={"homepage-social-icon"}>
									<FontAwesomeIcon
										icon={faPhone}
										style={{minWidth: 40}}
									/>
									<span className={"homepage-social-phone"}>{INFO.socials.phone}</span>
								</span>
						</li>
						<ul className="homepage-socials">
							<li className={"social-li"}>
								<a
									href={`mailto:${INFO.main.email}`}
									target="_blank"
									rel="noreferrer"
									className={"homepage-social-icon"}
								>
									<FontAwesomeIcon
										icon={faMailBulk}
										style={{minWidth: 40}}
									/>
									<span className={"homepage-social-text"}>{INFO.main.email}</span>
								</a>
							</li>
							<li className={"social-li"}>
								<a
									href={INFO.socials.github}
									target="_blank"
									rel="noreferrer"
									className={"homepage-social-icon"}
								>
									<FontAwesomeIcon
										icon={faGithub}
										style={{minWidth: 40}}
									/>
									<span className={"homepage-social-text"}>{INFO.socials.github}</span>
								</a>
							</li>
							<li className={"social-li"}>
								<a
									href={`${INFO.socials.itch}`}
									target="_blank"
									rel="noreferrer"
									className={"homepage-social-icon"}
								>
									<FontAwesomeIcon
										icon={faGamepad}
										style={{minWidth: 40}}
									/>
									<span className={"homepage-social-text"}>{INFO.socials.itch}</span>
								</a>
							</li>
							<li className={"social-li"}>
								<a
									href={`${INFO.socials.linkedin}`}
									target="_blank"
									rel="noreferrer"
									className={"homepage-social-icon"}
								>
									<FontAwesomeIcon
										icon={faLinkedin}
										style={{minWidth: 40}}
									/>
									<span className={"homepage-social-text"}>{INFO.socials.linkedin}</span>
								</a>
							</li>
						</ul>
						</ul>
						</div>

						<div className="homepage-projects">
							<div className="subheader">
								Work Experiences
							</div>
							<AllWorkExperiences/>
						</div>

						<div className="homepage-projects">
							<div className="subheader">
								Projects
							</div>
							<AllProjects/>
						</div>

						{/*<div className="homepage-after-title">*/}
						{/*	<div className="homepage-articles">*/}
						{/*		{myArticles.map((article, index) => (*/}
						{/*			<div*/}
						{/*				className="homepage-article"*/}
						{/*				key={(index + 1).toString()}*/}
						{/*			>*/}
						{/*				<Article*/}
						{/*					key={(index + 1).toString()}*/}
						{/*					date={article().date}*/}
						{/*					title={article().title}*/}
						{/*					description={article().description}*/}
						{/*					link={"/article/" + (index + 1)}*/}
						{/*				/>*/}
						{/*			</div>*/}
						{/*		))}*/}
						{/*	</div>*/}

						{/*	<div className="homepage-works">*/}
						{/*		<Works />*/}
						{/*	</div>*/}
						{/*</div>*/}

						<div className="page-footer">
							<Footer/>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Homepage;
